import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ChatIcon from "@material-ui/icons/Chat";
import {
  selectTab,
  seeUserProfileRequest,
  changeField,
  getManagerTeamRequest
} from "../../../services/manager/actions";
import Colors from "../../../constants/Colors";
import Tab from "../Tab";
import Snackbar from "../Snackbar";
import { LottieEmpty, Loader } from "../../../components/index";
import algoliasearch from "algoliasearch/lite";
import { InstantSearch, SearchBox } from "react-instantsearch-dom";
import Hits from "../Hits";
import Avatar from "../Avatar";
import UserProfile from "./UserProfile";
import moment from "moment";

import NotifsModal from "./NotifsModal";

const searchClient = algoliasearch(
  "MTMFJ78PRC",
  "a6400a80c85f1dcceaaddde616c096a3"
);

const styles = theme => ({
  main: {
    width: "90%",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // paddingTop: 20,
    paddingBottom: 100
  },
  root: {
    width: "90%",
    minHeight: 150,
    marginTop: theme.spacing.unit * 3,
    backgroundColor: "#FAFAFA",
    // backgroundColor: "#fff",
    overflowX: "auto"
  },
  inputForm: {
    marginTop: 15,
    marginBottom: 15,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start"
  },
  inputLabel: {
    marginRight: 10,
    marginLeft: 10
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    textOverflow: "ellipsis",
    overflow: "hidden",
    // whiteSpace: "nowrap",
    color: Colors.text,
    width: "90%"
  },
  title: {
    fontSize: theme.typography.pxToRem(15),
    marginBottom: 15,
    color: Colors.text
  },
  separator: {
    fontSize: theme.typography.pxToRem(15),
    marginBottom: 10,
    fontWeight: "bold",
    color: Colors.text
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  table: {
    minWidth: 700
  },
  actionRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
  },
  rowSelected: {
    backgroundColor: Colors.lightGrey
  },
  expansionDiv: {
    flex: 1
  },
  details: {
    flexDirection: "row",
    flex: 1,
    alignItems: "center",
    justifyContent: "flex-start"
  },
  checkDiv: {
    height: "100%"
    // backgroundColor: "#fff"
  },
  mainTitle: {
    alignSelf: "left",
    fontWeight: 500,
    marginBottom: 15
  },
  saveButton: {
    backgroundColor: Colors.main
  },
  noTeamDiv: {
    flex: 1,
    marginTop: 15,
    alignItems: "center",
    justifyContent: "center",
    display: "flex"
  },
  searchDiv: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-start",
    justifyContent: "center",
    flex: 1,
    marginTop: 15
  },
  avatar: {
    height: 50,
    width: 50,
    borderRadius: 8,
    // border: "solid",
    borderWidth: 1,
    borderColor: Colors.main
  },
  header: {
    marginTop: 10,
    paddingBottom: 10,
    borderBottom: "solid",
    borderBottomColor: Colors.lightGrey,
    borderBottomWidth: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
  },
  profile: {
    width: 700
  },
  paper: {
    flex: 1,
    display: "flex",
    overflow: "auto",
    margin: 20,
    maxHeight: 2300,
    // height: "calc(100% - 30px)",
    height: "calc(100% - 40px)",
    // minHeight: "100%",
    maxWidth: 2300
  },
  closeButton: {
    zIndex: 10,
    position: "absolute",
    top: 1,
    right: 1
  },
  centralDiv: {
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: "column"
  },
  button: {
    marginTop: 15,
    alignSelf: "center"
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  explanationDiv: {
    marginTop: 15,
    marginBottom: 5,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row"
  },
  dot: {
    backgroundColor: Colors.green,
    height: 20,
    width: 20,
    borderRadius: 10,
    marginRight: 10
  }
});

class MyTeam extends PureComponent {
  state = {
    open: false,
    isNotifsModalVisible: false,
    scroll: "paper"
  };

  componentDidMount() {
    this.props.getManagerTeamRequest(this.props.userId);
  }

  handleClose = () => {
    console.log("SAVE SURVEY !!");
    this.setState({ open: false });
  };

  selectSelectionTab = () => {
    this.props.selectTab(2);
  };

  onSelect = user => () => {
    // this.setState({ isVisible: true });
    this.props.changeField({ selectedManagerNoteIndex: 0 });
    this.props.seeUserProfileRequest({
      userId: user._id._id || user._id,
      managerId: this.props.userId
    });
    this.setState({ open: true });
    console.log("Holaaa");
  };

  displayNotifs = () => {
    this.setState({ isNotifsModalVisible: true });
  };

  onCloseNotifsModal = () => {
    this.setState({ isNotifsModalVisible: false });
  };

  getTotalDoneSinceAWeek = historical => {
    if (!historical || historical.length < 1) {
      return 0;
    }
    const lastWeek = moment().subtract(1, "week");
    const totalDoneSinceAWeek = historical.reduce((prev, curr) => {
      const isAfter = moment(curr.date).isAfter(lastWeek);
      return prev + isAfter;
    }, 0);
    return totalDoneSinceAWeek;
  };

  render() {
    const { classes, userSelected } = this.props;
    return (
      <div className={classes.main}>
        <Dialog
          classes={{ paper: classes.paper }}
          fullWidth
          maxWidth="lg"
          open={this.state.open}
          onClose={this.handleClose}
          scroll={this.state.scroll}
          aria-labelledby="scroll-dialog-title"
        >
          <IconButton
            className={classes.closeButton}
            onClick={this.handleClose}
          >
            <CloseIcon />
          </IconButton>
          <UserProfile />
        </Dialog>
        <NotifsModal
          isVisible={this.state.isNotifsModalVisible}
          onClose={this.onCloseNotifsModal}
          isTeamNotification
        />
        {this.props.requesting && <Loader />}
        {this.props.managerTeam.length < 1 ? (
          <div className={classes.noTeamDiv}>
            <Button
              onClick={this.selectSelectionTab}
              variant="contained"
              color="primary"
            >
              Constituer mon équipe
            </Button>
            <LottieEmpty />
          </div>
        ) : (
          <div className={classes.centralDiv}>
            <Button
              size="small"
              color="primary"
              variant="outlined"
              className={classes.button}
              onClick={this.displayNotifs}
            >
              <ChatIcon className={classes.leftIcon} />
              Envoyer une notification à l'équipe
            </Button>
            <div className={classes.explanationDiv}>
              <div className={classes.dot} />
              <Typography>
                Nombre d'actions réalisées depuis 1 semaine
              </Typography>
            </div>
            <div className={classes.searchDiv}>
              {this.props.managerTeam
                .filter(user => user._id)
                .sort((a, b) => b._id.experience - a._id.experience)
                .map(el => {
                  return (
                    <Avatar
                      strong
                      totalDoneSinceAWeek={this.getTotalDoneSinceAWeek(
                        el._id.historical
                      )}
                      experience={el._id.experience}
                      key={el._id._id || el._id}
                      id={el._id._id || el._id}
                      onClick={this.onSelect(el)}
                      firstName={el.firstName}
                      lastName={el.lastName}
                      picture={el.picture}
                      isMyTeam
                    />
                  );
                })}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    selectionList,
    requesting,
    tabSelected,
    managerTeam,
    userSelected,
    survey
  } = state.manager;
  const { clientId, userId } = state.client;
  return {
    survey,
    managerTeam,
    userSelected,
    clientId,
    userId,
    selectionList,
    requesting,
    tabSelected
  };
};

export default connect(
  mapStateToProps,
  {
    selectTab,
    seeUserProfileRequest,
    getManagerTeamRequest,
    changeField
  }
)(withStyles(styles)(MyTeam));
